import React from 'react';
import { useLanguage } from './LanguageContext';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-brand-deep text-white pt-10 md:pt-16 pb-8" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-12" data-id="element-30">
          {/* Brand */}
          <div data-id="element-31">
            <div className="flex items-center gap-3 mb-6" data-id="element-32">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-brand-deep font-bold text-lg" data-id="element-33">
                RB
              </div>
              <div data-id="element-34">
                <h3 className="font-bold text-lg leading-tight" data-id="element-35">
                  Reading Behavioral
                </h3>
                <p className="text-brand-sky text-sm" data-id="element-36">Health Center</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6" data-id="element-37">
              Providing compassionate, culturally responsive mental health care
              to our community.
            </p>
            <div className="flex gap-4" data-id="element-38">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-39">
                <Facebook className="w-5 h-5" data-id="element-40" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-41">
                <Instagram className="w-5 h-5" data-id="element-42" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-43">
                <Linkedin className="w-5 h-5" data-id="element-44" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-45">
            <h4 className="font-bold text-lg mb-6" data-id="element-46">{t('nav.services')}</h4>
            <ul className="space-y-3 text-gray-300 text-sm" data-id="element-47">
              <li data-id="element-48">
                <a href="#" className="hover:text-brand-sky transition-colors" data-id="element-49">
                  {t('service.psych')}
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="hover:text-brand-sky transition-colors" data-id="element-51">
                  {t('service.meds')}
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="hover:text-brand-sky transition-colors" data-id="element-53">
                  {t('service.therapy')}
                </a>
              </li>
              <li data-id="element-54">
                <a href="#" className="hover:text-brand-sky transition-colors" data-id="element-55">
                  {t('service.trauma')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-56">
            <h4 className="font-bold text-lg mb-6" data-id="element-57">{t('nav.contact')}</h4>
            <ul className="space-y-3 text-gray-300 text-sm" data-id="element-58">
              <li className="flex items-start gap-3" data-id="element-59">
                <span className="font-semibold text-white min-w-[60px]" data-id="element-60">
                  Phone:
                </span>
                <a href="tel:6103747035" className="hover:text-brand-sky" data-id="element-61">
                  (610) 374-7035
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-62">
                <span className="font-semibold text-white min-w-[60px]" data-id="element-63">
                  Address:
                </span>
                <span data-id="element-64">
                  40 S 5th St
                  <br data-id="element-65" />
                  Reading, PA 19602
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-66">
                <span className="font-semibold text-white min-w-[60px]" data-id="element-67">
                  Email:
                </span>
                <a href="mailto:info@readingbehavioral.com" className="hover:text-brand-sky" data-id="element-68">
                  info@readingbehavioral.com
                </a>
              </li>
            </ul>
          </div>

          {/* Emergency */}
          <div data-id="element-69">
            <h4 className="font-bold text-lg mb-6" data-id="element-70">Emergency</h4>
            <div className="bg-red-900/50 border border-red-800 p-4 rounded-xl" data-id="element-71">
              <p className="text-red-100 text-sm mb-2" data-id="element-72">
                If you are experiencing a medical emergency, please dial:
              </p>
              <p className="text-3xl font-bold text-white" data-id="element-73">911</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400" data-id="element-74">
          <p data-id="element-75">
            &copy; {new Date().getFullYear()} Reading Behavioral Health Center.
            All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-76">
            <a href="#" className="hover:text-white transition-colors" data-id="element-77">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-78">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}